import { render } from "./WheelIcon.vue?vue&type=template&id=33ca31bf"
import script from "./WheelIcon.vue?vue&type=script&lang=js"
export * from "./WheelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__